var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1992 68.2371C52.9769 68.2371 68.1992 53.0147 68.1992 34.2371C68.1992 15.4594 52.9769 0.237061 34.1992 0.237061C15.4215 0.237061 0.199219 15.4594 0.199219 34.2371C0.199219 53.0147 15.4215 68.2371 34.1992 68.2371Z",
    fill: "#EE3364"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2222 47.0001V44.2223C44.2222 42.7489 43.6369 41.3358 42.595 40.2939C41.5532 39.2521 40.1401 38.6667 38.6667 38.6667H27.5556C26.0821 38.6667 24.6691 39.2521 23.6272 40.2939C22.5853 41.3358 22 42.7489 22 44.2223V47.0001",
    stroke: "white",
    strokeWidth: 2.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1111 33.1111C36.1793 33.1111 38.6667 30.6238 38.6667 27.5556C38.6667 24.4873 36.1793 22 33.1111 22C30.0428 22 27.5555 24.4873 27.5555 27.5556C27.5555 30.6238 30.0428 33.1111 33.1111 33.1111Z",
    stroke: "white",
    strokeWidth: 2.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a2d7bbd7f489638d6ea46ccbb86b76e6.svg";
export { ForwardRef as ReactComponent };